"use client";

import { create } from "zustand";
import { getMenus, getWebInfo } from "lib/getFetchers";

const normalizeWebInfo = (info) =>
  Array.isArray(info) ? info[0] || {} : info || {};

export const useWebInfoStore = create((set, get) => ({
  webInfo: null,
  menus: [],
  loading: false,
  loaded: false,
  error: null,
  setInitialData: ({ webInfo, menus }) => {
    const nextInfo = webInfo ? normalizeWebInfo(webInfo) : null;
    const nextMenus = Array.isArray(menus) ? menus : [];
    set((state) => ({
      webInfo: nextInfo ?? state.webInfo,
      menus: nextMenus.length ? nextMenus : state.menus,
      loaded: state.loaded || Boolean(nextInfo) || nextMenus.length > 0,
    }));
  },
  fetchAll: async () => {
    const { loaded, loading } = get();
    if (loaded || loading) return;
    set({ loading: true, error: null });
    try {
      const lang = "mn";
      const [{ info }, { menus }] = await Promise.all([
        getWebInfo(lang),
        getMenus(),
      ]);
      set({
        webInfo: normalizeWebInfo(info),
        menus: Array.isArray(menus) ? menus : [],
        loaded: true,
        loading: false,
      });
    } catch (error) {
      set({ error, loading: false });
    }
  },
}));
